import { apiService } from './APIService';

export const CRUDFactory = (url) => ({
  getAll(params) { return apiService.get(url, params); },

  getCashed(params) {
    return apiService.getCached(url, params);
  },

  get(id, params) {
    return apiService.get(`${url}/${id}`, params);
  },

  create(data) {
    return apiService.post(url, data);
  },

  update(id, data) {
    return apiService.put(`${url}/${id}`, data);
  },

  delete(id) {
    return apiService.delete(`${url}/${id}`);
  },
});
